import React from "react";
import classes from "./Footer.module.css";
import logo from "../../assests/img/bmps-rmbg.png";

const Footer = () => {
  return (
    <div className={classes["footer"]}>
      <div className={classes["footer-container"]}>
        <p
          style={{ color: "#fff", fontWeight: "500",letterSpacing:'3px' }}
        >
          BMPS LEARNING MYANMAR
        </p>
        <p
          style={{ color: "#fff", fontWeight: "100",marginTop:15 }}
        >
          © 2022, All Rights Reserved.
        </p>
        <p
          style={{ color: "#fff", fontWeight: "100",marginTop:15 }}
        >
          Developed by Kyaw Gyi
        </p>
      </div>
    </div>
  );
};

export default Footer;
